import { automationTherapistResponse } from '@/modules/permissionsToogle/domain/models/automationTherapistResponse'

import { axios, Response } from '..'

const updateVisibilityPermissionAutomatic = (
  automationGroupId: string
): Response<automationTherapistResponse> => {
  return axios.put(`/v1/automation-groups/${automationGroupId}/send-only`)
}
export default updateVisibilityPermissionAutomatic
